import AccessControl from '@/components/access-control/AccessControl.component';
import { useDialog } from '@/contexts/DialogContext';
import { FeatureLevelPermissions } from '@/models/UserPermissions.model';
import { Button, Grid, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

import React, { useState } from 'react';

import { AmendmentsFilters } from './components/AmendmentsFilters.component';
import {
  AmendmentStatus,
  CreateNewAmendmentDialog
} from './components/CreateNewAmendmentDialog.component';
import { StatusAccordion } from './components/StatusAccordion.component';

export const defaultFilters: AmendmentsFilters = {
  adminStatus: '',
  assignee: '',
  billableAmount: [],
  firmId: '',
  productTierId: [],
  search: '',
  searchType: ''
};

export const AmendmentsPage: React.FC = () => {
  const { closeDialog, openDialog } = useDialog();
  const [expandedPanel, setExpandedPanel] = useState<string>('');
  const [updatedFilters, setUpdatedFilters] = useState(defaultFilters);

  const handleAccordionChange =
    (panel: string) =>
    (event: React.SyntheticEvent, expandedPanel: boolean) => {
      setExpandedPanel(expandedPanel ? panel : '');
    };

  return (
    <Grid container data-testid='amendments-page' gap={4}>
      <Grid container justifyContent='space-between'>
        <Typography variant='h4'>Plan Amendments</Typography>
        <AccessControl requires={[FeatureLevelPermissions.WRITE_AMENDMENTS]}>
          <Button
            color='primary'
            data-testid='new-amendment-button'
            onClick={() => {
              openDialog({
                customContent: (
                  <CreateNewAmendmentDialog
                    close={closeDialog}
                    updatedFilters={updatedFilters}
                  />
                ),
                dialogProps: { maxWidth: 'md' }
              });
            }}
            variant='contained'>
            New Amendment
          </Button>
        </AccessControl>
      </Grid>

      <Grid container gap={2} wrap='nowrap'>
        <Grid border={1} borderColor={grey[300]} borderRadius={1}>
          <AmendmentsFilters setUpdatedFilters={setUpdatedFilters} />
        </Grid>

        <Grid container gap={3}>
          {Object.values(AmendmentStatus).map((status, index) => (
            <Grid key={index} width='100%'>
              <StatusAccordion
                expanded={expandedPanel === status}
                onChange={handleAccordionChange(status)}
                status={status}
                updatedFilters={updatedFilters}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
